import UISideNav from 'UIComponents/nav/UISideNav';
import styled from 'styled-components';
import { BATTLESHIP, GREAT_WHITE } from 'HubStyleTokens/colors';
import HR from 'UIComponents/elements/HR';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import { ShinySkeletonText } from '../helpers/ShinySkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledWrapper = styled.div.withConfig({
  displayName: "UniversalAssociationsSelectSideNavSkeleton__StyledWrapper",
  componentId: "sc-1mo9zu-0"
})(["min-width:160px;width:160px;border-right:1px solid ", ";"], GREAT_WHITE);
export const StyledHR = styled(HR).withConfig({
  displayName: "UniversalAssociationsSelectSideNavSkeleton__StyledHR",
  componentId: "sc-1mo9zu-1"
})(["background-color:", ";"], BATTLESHIP);
export const UniversalAssociationsSelectSideNavSkeleton = () => {
  return /*#__PURE__*/_jsxs(StyledWrapper, {
    className: "p-bottom-2 p-left-3 p-top-2 overflow-y-scroll",
    children: [/*#__PURE__*/_jsx(UISideNav, {
      "aria-label": "Selected Associations Skeleton",
      className: "m-bottom-0 m-top-0",
      children: /*#__PURE__*/_jsx(UISideNavItem, {
        active: true,
        title: /*#__PURE__*/_jsx(ShinySkeletonText, {}),
        count: /*#__PURE__*/_jsx(ShinySkeletonText, {
          width: 15
        })
      })
    }), /*#__PURE__*/_jsx(StyledHR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(UISideNav, {
      "aria-label": "Other Associations Skeleton",
      className: "m-bottom-0 m-top-1",
      children: Array.from({
        length: 5
      }, (_, index) => /*#__PURE__*/_jsx(UISideNavItem, {
        title: /*#__PURE__*/_jsx(ShinySkeletonText, {}),
        count: /*#__PURE__*/_jsx(ShinySkeletonText, {
          width: 15
        })
      }, index))
    })]
  });
};